import { PardotFormLandingPagesTab } from './PardotFormLandingPagesTab';
import { PardotRuleReferencesTab } from '@periscopes/general/pardot-rules';
import { PERISCOPE_TAB_TYPES } from '@sonar-software/sonar-ts-constants';
import { PeriscopeBodyComponent } from '@periscopes/types';
import React from 'react';
import { SonarObjectType } from '@sonar-software/sonar-ts-types';

import { PardotFormCompletionActionsTab, PardotFormFieldsTab } from '.';
import { PeriscopeMenuTabs, PeriscopeTabArea } from '@periscopes/general';

export const PardotFormScope: PeriscopeBodyComponent = ({ data, index }) => {
	const { sonarObjectId, relatedCounts } = data;

	return (
		<PeriscopeMenuTabs>
			<PeriscopeTabArea
				count={ relatedCounts[ SonarObjectType.PardotField ] ?? 0 }
				key={ PERISCOPE_TAB_TYPES.FIELDS }
				requiresCount
				tab={ PERISCOPE_TAB_TYPES.FIELDS }>
				<PardotFormFieldsTab
					index={ index }
					sonarObjectId={ sonarObjectId } />
			</PeriscopeTabArea>
			<PeriscopeTabArea
				count={ relatedCounts[ SonarObjectType.PardotLandingPage ] ?? 0 }
				key={ PERISCOPE_TAB_TYPES.LANDING_PAGES }
				requiresCount
				tab={ PERISCOPE_TAB_TYPES.LANDING_PAGES }>
				<PardotFormLandingPagesTab
					index={ index }
					sonarObjectId={ sonarObjectId } />
			</PeriscopeTabArea>
			<PeriscopeTabArea
				count={ relatedCounts.pardotCompletionAction ?? 0 }
				key={ PERISCOPE_TAB_TYPES.COMPLETION_ACTIONS }
				requiresCount
				tab={ PERISCOPE_TAB_TYPES.COMPLETION_ACTIONS }>
				<PardotFormCompletionActionsTab
					index={ index }
					sonarObjectId={ sonarObjectId } />
			</PeriscopeTabArea>
			<PeriscopeTabArea
				count={ relatedCounts.pardotAutomationRuleReference ?? 0 }
				key={ PERISCOPE_TAB_TYPES.RULE_REFERENCES }
				requiresCount
				tab={ PERISCOPE_TAB_TYPES.RULE_REFERENCES }>
				<PardotRuleReferencesTab
					index={ index }
					sonarObjectId={ sonarObjectId } />
			</PeriscopeTabArea>
		</PeriscopeMenuTabs>
	);
};
